import React, { Component } from "react";
import { Modal, Button, Form, Select, message } from "antd";
import SelectUserV4 from "nbugs-select-user-result-v4.0";
import FormCreate from "../../../../../components/FormCreate/index";
import deleteIcon from "../../Images/delete.svg";
import "./index.less";

const { FormSelect } = FormCreate;
let lessonClassRoomId = 0;

let noRepeatRoomList = [];

@Form.create()
class index extends Component {
  constructor(props) {
    super(props);
    const { regionList } = props;
    const initKeysValue = [];
    const tempSelectIdList = [];
    const tempRegionOrgIdList = [];
    const tempRegionNameList = [];
    if (regionList && regionList.length) {
      regionList.forEach((item, number) => {
        initKeysValue.push(number);
        lessonClassRoomId = number + 1;
        tempSelectIdList.push(item.selectId);
        tempRegionOrgIdList.push(item.regionOrgId);
        tempRegionNameList.push(item.regionName);
      });
    } else {
      initKeysValue.push(0);
      lessonClassRoomId = 1;
      tempSelectIdList.push("");
      tempRegionNameList.push("");
      tempRegionOrgIdList.push("");
    }
    this.state = {
      initKeysValue,
      selectIdList: tempSelectIdList,
      regionOrgIdList: tempRegionOrgIdList,
      regionNameList: tempRegionNameList
    };
    // this.handleUpdateRoomList();
  }

  // 点击取消按钮
  handleCancel = () => {
    const { onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
  };

  // 点击确定按钮
  handleOk = e => {
    e.preventDefault();
    e.stopPropagation();
    const { onOk, form } = this.props;
    const { regionOrgIdList, regionNameList, selectIdList } = this.state;
    const { validateFields } = form;
    validateFields((errors, values) => {
      if (!errors) {
        const { keys, supplierRegionId: supplierRegionIdList } = values;
        const selectRegionList = [];
        keys.forEach(k => {
          selectRegionList.push({
            regionName: regionNameList[k],
            regionOrgId: regionOrgIdList[k],
            selectId: selectIdList[k],
            supplierRegionId: supplierRegionIdList[k]
          });
        });
        const noRepeat = this.handleCheckRepeatClass(selectRegionList);
        if (!noRepeat) {
          message.warning("存在重复的已选教室，请修改后提交");
        } else if (onOk) {
          onOk(selectRegionList);
        }
      } else {
        return null;
      }
    });
  };

  // 检验是否有重复的听课教室
  handleCheckRepeatClass = selectRegionList => {
    const tempIdList = selectRegionList.map(item => item.supplierRegionId);
    const tempIdListSet = new Set(tempIdList);
    return tempIdListSet.size === tempIdList.length;
  };

  // 去除已选的听课教室
  // handleUpdateRoomList = () => {
  //   const { form, selectRoomList } = this.props;
  //   const { getFieldsValue } = form;
  //   const { supplierRegionId = [] } = getFieldsValue();
  //   const tempArr = [];
  //   selectRoomList.forEach(item => {
  //     const i = supplierRegionId.findIndex(
  //       value => value === item.supplierRegionId
  //     );
  //     if (i === -1) {
  //       tempArr.push(item);
  //     }
  //   });
  //   noRepeatRoomList = tempArr;
  // };

  // 选中某个教室之后保存key值
  handleSetSelectClassRoomKey = (k, option) => {
    const { regionNameList, regionOrgIdList } = this.state;
    const tempRegionOrgIdList = [...regionOrgIdList];
    const tempRegionNameList = [...regionNameList];
    const { key, props } = option;
    const { children } = props;
    tempRegionOrgIdList[k] = key;
    tempRegionNameList[k] = children;
    this.setState({
      regionOrgIdList: tempRegionOrgIdList,
      regionNameList: tempRegionNameList
    });
    // this.handleUpdateRoomList();
  };

  // 下拉框状态更改时的回调
  // handleDropDown = (k, open) => {
  //   const { form } = this.props;
  //   const { getFieldsValue } = form;
  //   const { supplierRegionId = [] } = getFieldsValue
  //   if(open && supplierRegionId[k]) {
  //     const i = noRepeatRoomList.findIndex(value => value === supplierRegionId[k])
  //     if(i === -1) {
  //       noRepeatRoomList.push(supplierRegionId[k])
  //     }
  //   } else if(!open){
  //     this.handleUpdateRoomList()
  //   }
  // };

  // 点击新增听课教室
  handleAddNewLessonClassRoom = () => {
    this.handleUpdateList(lessonClassRoomId);
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    /* eslint-disable-next-line */
    const nextKeys = keys.concat(lessonClassRoomId++);
    form.setFieldsValue({
      keys: nextKeys
    });
  };

  // 移除听课教室k
  handleDelete = k => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length === 1) {
      return;
    }
    this.handleUpdateList(k);
    form.setFieldsValue({
      keys: keys.filter(key => key !== k)
    });
    // this.handleUpdateRoomList();
  };

  // 增加 || 移除时 更新自己保存的数据
  handleUpdateList = k => {
    const { selectIdList, regionOrgIdList, regionNameList } = this.state;
    const tempSelectIdList = [...selectIdList];
    const tempRegionOrgIdList = [...regionOrgIdList];
    const tempRegionNameList = [...regionNameList];
    tempSelectIdList[k] = "";
    tempRegionOrgIdList[k] = "";
    tempRegionNameList[k] = "";
    this.setState({
      selectIdList: tempSelectIdList,
      regionOrgIdList: tempRegionOrgIdList,
      regionNameList: tempRegionNameList
    });
  };

  // 选人组件修改，需要更新selectIdList
  handleChange = (value, k) => {
    const { selectIdList = [] } = this.state;
    const { selectSignature } = value;
    const tempSelectIdList = [...selectIdList];
    tempSelectIdList[k] = selectSignature;
    this.setState({
      selectIdList: tempSelectIdList
    });
  };

  // 弹框底部的渲染
  renderModalFooter = () => {
    return (
      <div className="footerContainer">
        <div className="tip">最多可选择8个听课教室</div>
        <div className="buttonContainer">
          <Button onClick={this.handleCancel}>取消</Button>
          <Button onClick={this.handleOk} type="primary">
            确认
          </Button>
        </div>
      </div>
    );
  };

  // body部分
  renderContent = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    return (
      <div className="lessonClassRoomContainer">
        <FormCreate>{this.renderListenClassRoomItem()}</FormCreate>
        {keys && keys.length < 8 && (
          <div className="button">
            <Button onClick={this.handleAddNewLessonClassRoom}>
              + 新增听课教室
            </Button>
          </div>
        )}
      </div>
    );
  };

  // 渲染每个听课教室
  renderListenClassRoomItem = () => {
    const { form, regionList, selectRoomList, formItemLayout } = this.props;
    const { selectIdList } = this.state;
    const { getFieldValue } = form;
    const keys = getFieldValue("keys") || [];

    return keys.map((k, number) => {
      const lessonSelectProps = {
        placeholder: "请选择"
      };

      const listenClassRoomProps = {
        form,
        label: "听课教室",
        value: regionList[k]?.supplierRegionId || undefined,
        keyName: `supplierRegionId[${k}]`,
        selfValue: "supplierRegionId",
        selfLabel: "regionName",
        selfKey: "regionOrgId",
        message: "请选择听课教室",
        placeholder: "请选择",
        optionData: selectRoomList,
        // optionData: noRepeatRoomList,
        isRequired: true,
        onSelect: (value, option) => {
          this.handleSetSelectClassRoomKey(k, option);
        },
        // onDropdownVisibleChange: open => {
        //   this.handleDropDown(k, open);
        // }
      };

      const selectUserProps = {
        selectType: "user",
        strictOrgRel: false,
        showTabList: [
          "dept",
          "innerContacts",
          "group",
          "schoolContacts",
          "orgRel"
        ],
        dialogProps: {
          title: "选择辅助教师"
        },
        searchPlaceholder: "搜索辅助教师",
        selectSignature: selectIdList[k],
        isSaveSelectSignature: true,
        requestParams: {
          selectTypeList: ["user"]
        }
      };

      return (
        <div className="itemContainer">
          <div className="classRoomTitle">听课教室{number + 1}</div>
          <div className="formContainer">
            <FormSelect {...listenClassRoomProps} key={k} />
            <Form.Item label="辅助教师" {...formItemLayout} className='subTeacherSelect'>
              <SelectUserV4
                selectUserProps={selectUserProps}
                onChange={value => {
                  this.handleChange(value, k);
                }}
                key={k}
              />
            </Form.Item>
          </div>
          {keys && keys.length > 1 && (
            <div className="deleteContainer">
              <img
                onClick={() => this.handleDelete(k)}
                alt=""
                src={deleteIcon}
              />
            </div>
          )}
        </div>
      );
    });
  };

  render() {
    const { visible, onCancel, form } = this.props;
    const { initKeysValue } = this.state;
    const { getFieldDecorator } = form;
    getFieldDecorator("keys", { initialValue: initKeysValue || [] });
    const listenModalProps = {
      visible,
      onCancel,
      title: "听课教室",
      wrapClassName: "listen-class-modal-container",
      footer: this.renderModalFooter(),
      maskClosable: false
    };
    return <Modal {...listenModalProps}>{this.renderContent()}</Modal>;
  }
}

export default index;
